/**
 * Created by andyosullivan on 15/06/2024
 */

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './containers/Home/Home';
import {DonateDetailsSection} from "./containers/Donate/DonateDetailsSection";
import Governance from "./containers/Governance/Governance";
import Services from "./containers/Services/Services";
import {Contact} from  "./containers/Contact/Contact";

function NewRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/donate" element={<DonateDetailsSection />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/governance" element={<Governance />} />
        </Routes>
    );
}

export default NewRoutes;





